module.exports = __webpack_public_path__ + "img/nrg-org-v2.b6fb693d.jpg";